import { useState } from 'react';
import team from '../Assets/TeamandOthers/Team.webp'
import clinic1 from '../Assets/TeamandOthers/Interiorimg.webp'
import clinic2 from '../Assets/TeamandOthers/clinic1.webp'
import clinic3 from '../Assets/TeamandOthers/clinic3.webp'
import clinic4 from '../Assets/TeamandOthers/clinic4.webp'
import gallery1 from '../Assets/TeamandOthers/Gallery3.jpg'
import gallery2 from '../Assets/TeamandOthers/Gallery4.jpg'
import gallery3 from '../Assets/TeamandOthers/Gallery13.jpg'
import gallery4 from '../Assets/TeamandOthers/Gallery5.jpg'
import gallery5 from '../Assets/TeamandOthers/Gallery7.jpg'
import gallery6 from '../Assets/TeamandOthers/Gallery8.jpg'
import gallery7 from '../Assets/TeamandOthers/Gallery9.jpg'
import gallery8 from '../Assets/TeamandOthers/Gallery11.jpg'
import gallery9 from '../Assets/TeamandOthers/Gallery12.jpg'


import reception from '../Assets/TeamandOthers/Reception.webp'
import beforeAfter1 from '../Assets/TeamandOthers/before_after1-2.webp'
import beforeAfter2 from '../Assets/TeamandOthers/before_after2.webp'
import Awardimg1 from '../Assets/Awards/Picture7.webp'
import Awardimg2 from '../Assets/Awards/Awardimg2.webp'
import Awardimg3 from '../Assets/Awards/Picture3.webp'
import Awardimg4 from '../Assets/Awards/Awardimg6.jpg'
import Awardimg5 from '../Assets/Awards/Awardimg5.jpg'
import Awardimg6 from '../Assets/Awards/Awardimg8.jpg'
import Awardimg7 from '../Assets/Awards/Awardimg7.jpg'
import Awardimg8 from '../Assets/Awards/Awardimg3.webp'
import Awardimg9 from '../Assets/Awards/Awardimg9-1.jpg'
import Awardimg10 from '../Assets/Awards/Awardimg10-1.jpg'
import Awardimg11 from '../Assets/Awards/Awardimg11-1.jpg'
import Awardimg12 from '../Assets/Awards/Awardimg12-1.jpg'

import team2 from '../Assets/TeamandOthers/Team2.webp'
import team3 from '../Assets/TeamandOthers/Team3-1.webp'
import team4 from '../Assets/TeamandOthers/Team4.webp'
import team5 from '../Assets/TeamandOthers/Team5.webp'
import team6 from '../Assets/TeamandOthers/Team6.webp'
import team7 from '../Assets/TeamandOthers/Team7.webp'
import team8 from '../Assets/TeamandOthers/Team8.webp'
import team9 from '../Assets/TeamandOthers/Team11-1.webp'
import team10 from '../Assets/TeamandOthers/Team10.webp'
import team11 from '../Assets/TeamandOthers/Team11.webp'
import treatementsimg1 from '../Assets/Services/Treatments1.webp'
import treatementsimg2 from '../Assets/Services/Treatments2-1.webp'
import treatementsimg3 from '../Assets/Services/Treatments3.webp'
import treatementsimg4 from '../Assets/Services/Treatments4.webp'
import treatementsimg5 from '../Assets/Services/Treatments5.webp'
import treatementsimg6 from '../Assets/Services/Treatments7.webp'

import Certificate1 from '../Assets/Certificates/Certificate1.webp'
import Certificate2 from '../Assets/Certificates/Certificate2.webp'
import Certificate3 from '../Assets/Certificates/Certificate3.webp'
import Certificate4 from '../Assets/Certificates/Certificate4.webp'
import Certificate5 from '../Assets/Certificates/Certificate5.jpg'
import Certificate6 from '../Assets/Certificates/Certificate6.webp'
import Certificate7 from '../Assets/Certificates/Certificate7.webp'
import Certificate8 from '../Assets/Certificates/Certificate8.jpg'
import Certificate9 from '../Assets/Certificates/Certificate9.webp'
import Certificate10 from '../Assets/Certificates/Certificate10.webp'
import Certificate11 from '../Assets/Certificates/Certificate11.webp'
import Pressclicks1 from '../Assets/TeamandOthers/Pressclick1.webp'
import Pressclicks2 from '../Assets/TeamandOthers/Pressclick2.jpg'
import Pressclicks3 from '../Assets/TeamandOthers/Pressclick3.jpg'
import Pressclicks4 from '../Assets/TeamandOthers/Pressclick4.webp'
import Pressclicks5 from '../Assets/TeamandOthers/Pressclick5.webp'
import Pressclicks6 from '../Assets/TeamandOthers/Pressclick6.webp'
import Pressclicks7 from '../Assets/TeamandOthers/Pressclick7.webp'
import Pressclicks8 from '../Assets/TeamandOthers/Pressclick8.webp'

import video1 from '../Assets/videos/VideoTestimonial1.mp4'
import video2 from '../Assets/videos/VideoTestimonial2.mp4'
import video3 from '../Assets/videos/VideoTestimonial3.mp4'

import Timage1 from '../Assets/TeamandOthers/Timage1.jpg'
import Timage2 from '../Assets/TeamandOthers/Timage2.jpg'
import Timage3 from '../Assets/TeamandOthers/Timage3.jpg'

const galleryItems = [
  
  {
    id: 1,
    title: "Reception & Waiting Area",
    category: "Hospital",
    image: reception,
    description: "Comfortable and welcoming reception",
  },
  {
    id: 3,
    title: "Ugadi Puraskar",
    category: "Awards",
    image: Awardimg1,
    description: "Dr. Sridhar received excellence award from the Hon’ble Chief Minister of Andhra Pradesh Sri.N.Chandra Babu Naidu",
  },
  {
    id: 5,
    title: "Dental Team",
    category: "Team",
    image: team,
    description: "Our expert dentists and support staff",
  },
  {
    id: 6,
    title: "Laser Treatment in Progress",
    category: "Treatments",
    image: treatementsimg1,
    description: "Painless laser gum reshaping procedure",
  },
  {
    id: 7,
    title: "Implant Surgery Setup",
    category: "Treatments",
    image: treatementsimg2,
    description: "Advanced implant placement environment",
  },
  {
    id: 8,
    title: "Modern Clinic Interior",
    category: "Hospital",
    image: clinic1,
    description: "State-of-the-art treatment room with advanced equipment",
  },
  {
    id: 10,
    title: "National Child Welfare Award",
    category: "Awards",
    image: Awardimg9,
    description: "Dr. Sridhar Received “National Child Welfare Award” from Sri. Ramnath Kovind, Hon’ble President of India on 22-01-2019",
  },
  {
    id: 11,
    title: "Congratulating for receiving “National Child Welfare Award”",
    category: "Awards",
    image: Awardimg10,
    description: "Prime Minister of India Hon’ble Sri.Narendra Modi congratulating Dr.A.Sridhar Reddy for receiving “National Child Welfare Award” at New Delhi on 23-01-2019.",
  },
  {
    id: 12,
    title: "Gold Medal ",
    category: "Awards",
    image: Awardimg11,
    description: "Dr. Sridhar Received Gold Medal from Sri. Pranab Mukherjee, Hon’ble President of India on 30-08-2016 for the Humanitarian Service through Red Cross at Rashtrapati Bhavan.",
  },
  {
    id: 13,
    title: "NTR Trust Award",
    category: "Awards",
    image: Awardimg12,
    description: "Dr. Sridhar Received Prestigious “NTR Trust Award” from His Excellency Governor of Andhra Pradesh and Sri. N.Chandra Babu Naidu Chief Minister of Andhra Pradesh.",
  },
  {
    id: 14,
    title: "Certificate of Merit",
    category: "Awards",
    image: Awardimg2,
    description: "Dr. Sridhar received from Sri. J.P. Nadda Hon’ble Minister for Health, Govt. of India",
  },
  {
    id: 15,
    title: "Gold Medal",
    category: "Awards",
    image: Awardimg3,
    description: "Dr. Sridhar received from Sri. E.S.L. Narasimhan, Governor of Andhra Pradesh .",
  },
  {
    id: 16,
    title: "Meritorious Certificate ",
    category: "Awards",
    image: Awardimg6,
    description: "Dr. Sridhar received from Sri.BR Meena IAS District Collector, Krishna in 1998.",
  },
  {
    id: 17,
    title: "Trophy(RED CROSS)",
    category: "Awards",
    image: Awardimg5,
    description: "Dr. Sridhar Received Trophy along with the District Collector Sri.Navin Mittal IAS from His Excellency Governor of Andhra Pradesh Sri.N.D. Tiwari for the Best District  (RED CROSS) Branch in 2008.",
  },
  {
    id: 18,
    title: "OUTSTANDING DENTIST AWARD ",
    category: "Awards",
    image: Awardimg4,
    description: "Dr. Sridhar Received MOST COMMENDABLE OUTSTANDING DENTIST AWARD - 2017",
  },
  {
    id: 19,
    title: "OUTSTANDING DENTIST OF THE YEAR ",
    category: "Awards",
    image: Awardimg7,
    description: "Dr. Sridhar Received ‘OUTSTANDING DENTIST OF THE YEAR – 2014’ from Dr.Arun Jamakar, Vice – Chancellor, Maharashtra Heath University.",
  },
  {
    id: 20,
    title: "Seva Medal",
    category: "Awards",
    image: Awardimg8,
    description: "Dr. Sridhar Received  Seva Medal from His Excellency Governor of Andhra Pradesh Sri. E.S.L. Narasimhan.",
  },
  {
    id: 21,
    title: "Experienced Dental Professional",
    category: "Team",
    image: team2,
    description: "Committed to delivering exceptional dental care with professionalism and attention to detail."
  },
  {
    id: 22,
    title: "Dedicated Dental Specialist",
    category: "Team",
    image: team3,
    description: "Focused on providing high-quality treatment in a comfortable and supportive environment."
  },
  {
    id: 23,
    title: "Skilled Dental Practitioner",
    category: "Team",
    image: team4,
    description: "Bringing extensive knowledge and a patient-centered approach to every appointment."
  },
  {
    id: 24,
    title: "Qualified Oral Health Expert",
    category: "Team",
    image: team5,
    description: "Ensuring safe, effective, and personalized dental solutions for every patient."
  },
  {
    id: 25,
    title: "Professional Dental Care Provider",
    category: "Team",
    image: team6,
    description: "Delivering comprehensive dental services with integrity and excellence."
  },
  {
    id: 26,
    title: "Certified Dental Consultant",
    category: "Team",
    image: team7,
    description: "Dedicated to maintaining the highest standards of clinical care and patient satisfaction."
  },
  {
    id: 27,
    title: "Trusted Dental Associate",
    category: "Team",
    image: team8,
    description: "Committed to promoting long-term oral health through expert guidance and treatment."
  },
  {
    id: 28,
    title: "Expert in Modern Dentistry",
    category: "Team",
    image: team9,
    description: "Utilizing advanced techniques to provide reliable and effective dental care."
  },
  {
    id: 29,
    title: "Compassionate Dental Professional",
    category: "Team",
    image: team10,
    description: "Focused on patient comfort while delivering precise and attentive dental services."
  },
  {
    id: 30,
    title: "Experienced Oral Care Specialist",
    category: "Team",
    image: team11,
    description: "Providing consistent, high-quality dental care tailored to individual patient needs."
  },
  {
    id: 31,
    title: "Professional Certification",
    category: "Certifications",
    image: Certificate1,
    description: "Official documentation reflecting recognized professional credentials."
  },
  {
    id: 32,
    title: "Professional Certification",
    category: "Certifications",
    image: Certificate2,
    description: "Recognized certification demonstrating verified professional standing."
  },
  {
    id: 33,
    title: "Professional Certification",
    category: "Certifications",
    image: Certificate3,
    description: "Formal acknowledgment of established professional qualifications."
  },
  {
    id: 34,
    title: "Professional Certification",
    category: "Certifications",
    image: Certificate4,
    description: "Authorized credential representing adherence to recognized standards."
  },
  {
    id: 35,
    title: "Professional Certification",
    category: "Certifications",
    image: Certificate5,
    description: "Validated certification confirming professional recognition."
  },
  {
    id: 36,
    title: "Professional Certification",
    category: "Certifications",
    image: Certificate6,
    description: "Officially issued document reflecting professional credibility."
  },
  {
    id: 37,
    title: "Professional Certification",
    category: "Certifications",
    image: Certificate7,
    description: "Recognized professional document demonstrating established credentials."
  },
  {
    id: 38,
    title: "Professional Certification",
    category: "Certifications",
    image: Certificate8,
    description: "Certified record indicating acknowledged professional status."
  },
  {
    id: 39,
    title: "Professional Certification",
    category: "Certifications",
    image: Certificate9,
    description: "Formal certificate representing verified professional recognition."
  },
  {
    id: 40,
    title: "Professional Certification",
    category: "Certifications",
    image: Certificate10,
    description: "Official credential reflecting compliance with recognized professional requirements."
  },
  {
    id: 41,
    title: "Professional Certification",
    category: "Certifications",
    image: Certificate11,
    description: "Documented certification demonstrating professional authenticity and credibility."
  },
  {
    id: 42,
    title: "Media Recognition",
    category: "Press clicks",
    image: Pressclicks1,
    description: "Featured coverage highlighting our professional services and community presence."
  },
  {
    id: 43,
    title: "Press Coverage",
    category: "Press clicks",
    image: Pressclicks2,
    description: "Published acknowledgment showcasing our commitment to quality dental care."
  },
  {
    id: 44,
    title: "Media Feature",
    category: "Press clicks",
    image: Pressclicks3,
    description: "Editorial mention recognizing our contributions to the dental field."
  },
  {
    id: 45,
    title: "Public Recognition",
    category: "Press clicks",
    image: Pressclicks4,
    description: "Documented media appearance reflecting our professional reputation."
  },
  {
    id: 46,
    title: "Industry Highlight",
    category: "Press clicks",
    image: Pressclicks5,
    description: "Press acknowledgment emphasizing our dedication to patient care."
  },
  {
    id: 47,
    title: "News Mention",
    category: "Press clicks",
    image: Pressclicks6,
    description: "Media publication featuring our ongoing commitment to excellence."
  },
  {
    id: 48,
    title: "Editorial Spotlight",
    category: "Press clicks",
    image: Pressclicks7,
    description: "Recognized media spotlight reflecting our trusted professional standing."
  },
  {
    id: 49,
    title: "Media Appearance",
    category: "Press clicks",
    image: Pressclicks8,
    description: "Official press inclusion highlighting our established presence in the community."
  },
  {
    id: 50,
    title: "Advanced Laser Procedure",
    category: "Treatments",
    image: treatementsimg3,
    description: "Modern laser-based dental treatment performed with precision and care."
  },
  {
    id: 51,
    title: "Soft Tissue Laser Therapy",
    category: "Treatments",
    image: treatementsimg4,
    description: "Minimally invasive laser technique designed to enhance treatment accuracy."
  },
  {
    id: 52,
    title: "Precision Gum Contouring",
    category: "Treatments",
    image: treatementsimg5,
    description: "Laser-assisted procedure focused on improving gum aesthetics and symmetry."
  },
  {
    id: 53,
    title: "Innovative Dental Laser Care",
    category: "Treatments",
    image: treatementsimg6,
    description: "Advanced technology utilized to support effective and comfortable dental treatment."
  },
  {
    id: 54,
    title: "Patient Reception Area",
    category: "Hospital",
    image: clinic2,
    description: "A welcoming front-desk space designed to provide comfort and convenience for all visitors.",
  },
  {
    id: 55,
    title: "Clinic Waiting Lounge",
    category: "Hospital",
    image: clinic4,
    description: "A calm and well-appointed seating area ensuring a relaxed experience before appointments.",
  },
  {
    id: 56,
    title: "Advanced Dental Operatory",
    category: "Hospital",
    image: clinic3,
    description: "A clean and ergonomically designed space to ensure high-quality dental procedures.",
  },
  {
    id: 57,
    title: "Philip, America – Dental surgery",
    category: "Video Testimonials",
    video: video1,
    description: "From fear to confidence in just one day – thank you team!",
    thumbnail: Timage1,
  },
  {
    id: 58,
    title: "John Lesley, England – Bridges and Crowns",
    category: "Video Testimonials",
    video: video2,
    description: "I never thought my smile could look this natural again!",
    thumbnail: Timage2,
  },
  {
    id: 59,
    title: "Paul Disher, Australia – Implants",
    category: "Video Testimonials",
    video: video3,
    description: "Painless treatment and excellent follow-up care.",
    thumbnail: Timage3,
  },
  {
  id: 60,
  title: "Hospital Facilities",
  category: "Hospital",
  image: gallery1,
  description: "Explore our modern hospital environment designed to provide comfort, safety, and high-quality medical care for every patient."
},
{
  id: 61,
  title: "Hospital Facilities",
  category: "Hospital",
  image: gallery2,
  description: "Explore our modern hospital environment designed to provide comfort, safety, and high-quality medical care for every patient."
},
{
  id: 62,
  title: "Hospital Facilities",
  category: "Hospital",
  image: gallery3,
  description: "Explore our modern hospital environment designed to provide comfort, safety, and high-quality medical care for every patient."
},
{
  id: 63,
  title: "Hospital Facilities",
  category: "Hospital",
  image: gallery4,
  description: "Explore our modern hospital environment designed to provide comfort, safety, and high-quality medical care for every patient."
},
{
  id: 64,
  title: "Hospital Facilities",
  category: "Hospital",
  image: gallery5,
  description: "Explore our modern hospital environment designed to provide comfort, safety, and high-quality medical care for every patient."
},
{
  id: 65,
  title: "Hospital Facilities",
  category: "Hospital",
  image: gallery6,
  description: "Explore our modern hospital environment designed to provide comfort, safety, and high-quality medical care for every patient."
},
{
  id: 66,
  title: "Hospital Facilities",
  category: "Hospital",
  image: gallery7,
  description: "Explore our modern hospital environment designed to provide comfort, safety, and high-quality medical care for every patient."
},
{
  id: 67,
  title: "Hospital Facilities",
  category: "Hospital",
  image: gallery8,
  description: "Explore our modern hospital environment designed to provide comfort, safety, and high-quality medical care for every patient."
},
{
  id: 68,
  title: "Hospital Facilities",
  category: "Hospital",
  image: gallery9,
  description: "Explore our modern hospital environment designed to provide comfort, safety, and high-quality medical care for every patient."
},

];

const categories = ["Hospital", "Treatments", "Team", "Video Testimonials", "Awards", "Certifications", "Press clicks", "Before/After"];

const Gallery = () => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [expandedCategories, setExpandedCategories] = useState({});

  const toggleCategory = (category) => {
    setExpandedCategories(prev => ({
      ...prev,
      [category]: !prev[category]
    }));
  };

  return (
    <main className="min-h-screen bg-gray-50">
      {/* Hero */}
      <section className="bg-gradient-to-r from-blue-700 to-blue-900 text-white py-16 md:py-24">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 tracking-tight">
            Gallery
          </h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto opacity-90">
            A glimpse into our Hospital, treatments, happy patients, and proud moments
          </p>
        </div>
      </section>

      {/* Gallery Sections */}
      <div className="container mx-auto px-6 py-12">
        {categories.map((cat) => {
          const itemsInCategory = galleryItems.filter(item => item.category === cat);
          if (itemsInCategory.length === 0) return null;

          const isExpanded = expandedCategories[cat];
          const displayedItems = isExpanded ? itemsInCategory : itemsInCategory.slice(0, 8);

          return (
            <section key={cat} className="mb-20">
              {/* Category Header */}
              <div className="flex items-center mb-8">
                <h2 className="text-2xl md:text-3xl font-bold text-blue-900 whitespace-nowrap mr-6">
                  {cat}
                </h2>
                <div className="h-px bg-gray-300 w-full"></div>
              </div>

              {/* Grid */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {displayedItems.map((item) => (
                  <div
                    key={item.id}
                    className="group relative aspect-[4/3] rounded-xl overflow-hidden shadow-md cursor-pointer hover:shadow-2xl transition-all duration-300"
                    onClick={() => setSelectedItem(item)}
                  >
                    {item.video ? (
                      <div className="w-full h-full bg-black">
                        <img 
                            src={item.thumbnail} 
                            alt={item.title} 
                            className="w-full h-full object-cover opacity-80"
                            loading="lazy"
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                          <div className="w-16 h-16 rounded-full bg-blue-600/90 flex items-center justify-center shadow-lg transform group-hover:scale-110 transition-transform">
                            <svg className="w-8 h-8 text-white ml-1" fill="currentColor" viewBox="0 0 24 24">
                              <path d="M8 5v14l11-7z" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <img
                        src={item.image}
                        alt={item.title}
                        className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                        loading="eager" /* Changed from lazy to eager */
                      />
                    )}

                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                      <div className="p-4 w-full">
                        <h3 className="text-white text-sm font-semibold line-clamp-2">
                          {item.title}
                        </h3>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {itemsInCategory.length > 8 && (
                <div className="mt-10 text-center">
                  <button
                    onClick={() => toggleCategory(cat)}
                    className="px-10 py-2.5 border-2 border-blue-600 text-blue-600 font-bold rounded-full hover:bg-blue-600 hover:text-white transition-all duration-300"
                  >
                    {isExpanded ? "VIEW LESS" : "VIEW MORE"}
                  </button>
                </div>
              )}
            </section>
          );
        })}
      </div>

      {/* Modal / Lightbox */}
      {selectedItem && (
        <div
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedItem(null)}
        >
          <div
            className="relative max-w-5xl w-full max-h-[90vh] flex flex-col items-center"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="absolute -top-12 right-0 md:-right-10 text-white text-4xl hover:text-blue-400 transition-colors"
              onClick={() => setSelectedItem(null)}
            >
              &times;
            </button>

            {selectedItem.video ? (
              <div className="w-full bg-black rounded-lg overflow-hidden">
                <video
                  src={selectedItem.video}
                  controls
                  autoPlay
                  className="w-full max-h-[70vh]"
                />
              </div>
            ) : (
              <img
                src={selectedItem.image}
                alt={selectedItem.title}
                className="max-w-full max-h-[75vh] object-contain rounded-lg shadow-2xl"
                loading="eager" /* Ensure modal images load instantly */
              />
            )}

            <div className="text-white text-center mt-6 px-4">
              <h3 className="text-xl md:text-2xl font-bold mb-2">{selectedItem.title}</h3>
              <p className="text-gray-300 text-sm md:text-base max-w-2xl">{selectedItem.description}</p>
            </div>
          </div>
        </div>
      )}
    </main>
  );
};

export default Gallery;